import Header from "./components/header";
import ReadMore from "./commons/readmore";
import BackToTop from "./commons/backtotop";
import closeAccordionMobile from "./commons/closeaccordionmobile";
import goToHash from "./commons/gotohash";
import goToAnchor from "./commons/gotoanchor";

import filterPageMedici from "./components/filter-medici";
import filterPageFaq from "./components/filter-faq";
import EventsCalendar from "./components/events-calendar";
import filterTariffe from "./components/filter-tariffe";
import filtersToggle from "./components/filters-toggle";
import tabSystem from "./components/tabs-custom";
import stickyMenu from "./components/sticky-menu";
import viewToggle from "./components/view-toggle";
import viewTogglev2 from "./components/view-toggle-v2";
import searchToggle from "./components/search-toggle";
import EventMap from "./components/event-map";
import Swipers from "./components/swipers";
import NewsSearch from "./components/news-search";
import PressVue from "./components/press-vue";
import AcademyVue from "./components/academy-vue";
import socialsShare from "./components/socials-share";
import readmoreToggle from "./commons/readmore-toggle";
//import Pubblicazioni from "./components/pubblicazioni";
import TimeLine from "./components/time-line";
import contactStrutture from "./components/contact-strutture";
import MapFilterMondi from "./components/map-filtermondi"
import MapFilterMondiArray from "./components/map-filtermondi-array"
import wizardSearch from "./components/wizard-search";
import tabHash from "./components/tab-hash";
import fakePagination from "./components/fake-pagination";
import offcanvasPrestazione from "./components/offcanvas-prestazione";
import mobileFilterList from "./components/mobile-filter-list";
import galleryGrid from "./components/gallery-grid";
import StickyBar from "./components/stickybar";
import strutRassegna from "./components/rassegna-stampa-struttura";
import strutCorsi from "./components/corsi-struttura";
import mappaRegione from "./components/mappa-regione";
import filterGruppoStrutture from "./components/gruppo-strutture-filter";
import vimeoplayers from "./components/vimeoplayers";
import jsonToXls from "./components/jsonToXls";

import 'lity';
import './vendors/fslightbox';
import BannerPrenotazioni from './components/banner-prenotazioni';
import algoliaFilters, {
	globalSearchWithAlgolia,
	performSearchOnPageLoad,
	searchWithAlgolia
} from './components/algolia';
import showMore from './components/showMore';
import pathologyIndex from './components/pathology-idex';
import LoadMoreAjax from './components/loadmore-ajax';
import GlobalSearch from './components/global-search';
import OnitFetches from './components/onit-fetches';
import OpenDay from './components/openday';
import gravityFormsApiProxy from './components/gform';
import MappaLinks from './components/mappa-links';

document.addEventListener("DOMContentLoaded", function () {
	let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
	let active = false;

	const lazyLoad = function () {
		if (active === false) {
			active = true;

			setTimeout(function () {
				lazyImages.forEach(function (lazyImage) {


					if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
						lazyImage.src = lazyImage.dataset.src;
						lazyImage.classList.remove("lazy");

						lazyImages = lazyImages.filter(function (image) {
							return image !== lazyImage;
						});

						if (lazyImages.length === 0) {
							document.removeEventListener("scroll", lazyLoad);
							window.removeEventListener("resize", lazyLoad);
							window.removeEventListener("orientationchange", lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};
	lazyLoad();
	document.addEventListener("scroll", lazyLoad);
	window.addEventListener("resize", lazyLoad);
	window.addEventListener("orientationchange", lazyLoad);
});

document.addEventListener("DOMContentLoaded", function() {
    Header();
    BackToTop();
    ReadMore.init()
    EventsCalendar();
    stickyMenu();
    EventMap();
    Swipers();
    closeAccordionMobile();
    socialsShare();
    //Pubblicazioni();
    TimeLine();
    PressVue();
    AcademyVue();
    NewsSearch();
    if (document.getElementById('sidebar__inner')) {
		StickyBar();
	}
    
    // Inizializza prima tabHash (priorità per le tab)
    if(document.querySelector('.tabHash')){
        tabHash();
    }
    
    // Poi gli altri gestori di anchor
    goToAnchor();
    
    // Infine goToHash con un piccolo delay per evitare conflitti
    setTimeout(() => {
        goToHash();
    }, 100);

    if (document.querySelector('.wizard-search') ) {
        wizardSearch();
    }

    if(document.querySelector('.filters')){
        filtersToggle();
    }
    if(document.querySelector('.view-toggle')){
        viewToggle();
    }
    if(document.querySelector('.view-toggle-v2')){
        viewTogglev2();
    }
    if(document.querySelector('.tabs-custom')){
        tabSystem();
    }
    if (document.getElementById('medici-vue') ) {
        filterPageMedici();
    }
    if (document.getElementById('tariffe-vue') ) {
        filterTariffe();
    }
    if(document.getElementById('faq-vue')){
        filterPageFaq();
    }
    if (document.querySelector('.readmore-toggle') ) {
        readmoreToggle();
    }
    if (document.getElementById('contact-strutture') ) {
        contactStrutture();
    }
    if (document.querySelector('.filter-search-conventions') ) {
        searchToggle();
    }
    if (document.querySelector('.fake-pagination') ) {
        fakePagination();
    }

    if (document.getElementById('offcanvasPrestazione') ) {
        offcanvasPrestazione();
    }

    if (document.querySelector('.gallery-grid') ) {
        galleryGrid();
    }
    if (document.getElementById('vue-strutStampa') ) {
        strutRassegna();
    }
    if (document.getElementById('vue-strutCorsi') ) {
        strutCorsi();
    }
	if (document.querySelector('.banner-prenotazioni')) {
		BannerPrenotazioni();
	}

	if (document.querySelector('.algolia-filters')) {
		algoliaFilters();
	}

	if (document.querySelector('.algolia-searchbox__input')) {
		searchWithAlgolia();
		performSearchOnPageLoad();
	}

	if (document.querySelector('.algolia-searchbox__input.--main-search')) {
		globalSearchWithAlgolia();
	}

	if (document.querySelector('.showMoreBtn')) {
		showMore();
	}

	if (document.querySelector('.pathology-content')) {
		pathologyIndex();
	}

	//AJAX LOADMORE
	if (document.getElementById('load-more-ajax')) {
		LoadMoreAjax();
	}

	if (document.querySelector('.global-search')) {
		GlobalSearch();
	}

	OnitFetches();

    jsonToXls();

    if (document.querySelector('.single-openday')) {
        OpenDay();
    }

    if (document.getElementById('regioni-select')) {
        MappaLinks();
    }

});

if (document.querySelector('.filters-list-wrapper')) {
	mobileFilterList();
}

if (document.getElementById('province_search_select2')) {
	mappaRegione();
}
if (document.querySelector('.filter_map')) {
	if (document.querySelector('.filter_map_array')) {

		MapFilterMondiArray();
	} else {
		MapFilterMondi();
	}
}

if (document.getElementById('gruppo-strutture-vue')) {
	filterGruppoStrutture();
}

// Rimosso goToHash() da qui - ora è dentro DOMContentLoaded
vimeoplayers();
gravityFormsApiProxy();
